import "animate.css"
import { configLoggedOut, Formatter, FormGf, IcCheck, IcEmail, IcSelect, IcText, navigationWeb, setData, useApi, userLoggedIn, userLoggedOut } from 'gf-ui'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Col, Container, Image, Row } from 'react-bootstrap'
import { FaHome } from 'react-icons/fa'
import { FaPhone } from "react-icons/fa6"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { API_SERVICES, TIPI_UTENTI_WEB } from "."
import { apiConf } from '../api/apiConf'
import homeSplash from '../assets/images/home-splash.jpg'
import { apiActions } from '../reducer/slice/apiSlice'
import "./Home.scss"

const Header = ({ testoPerAccedere=false }) => {
  return (
    <div className='w-100 bg-white' style={{ borderBottom: "3px solid var(--bs-primary)", boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)" }}>
      <Row className='m-0 p-0'>
        <Col xs={12} md={6} lg={4} xl={3} className='m-0 p-0 border-top'>
          <Image src={homeSplash} className="w-100" />
        </Col>
        <Col xs={12} md={6} lg={8} xl={9} className='mb-4 m-0 p-4 border-top d-flex flex-column align-items-start justify-content-between'>
          <Image src={`${window.globalConfig?.url_backend_default}${window.globalConfig?.sts || 'stsInternet'}/images/layout/web/logoEnte.jpg`} alt="logo ente" style={{ maxWidth: '300px', maxHeight: '100px' }} />
          <h1 className='text-primary display-4 fw-bold'>PORTALE MEDICI</h1>
          { testoPerAccedere && <h5 className='text-primary'>Per accedere clicca sulla voce del servizio di tuo interesse.</h5> }
        </Col>
      </Row>
    </div>
  )
}

const Home = () => {  
  const user = useSelector( state => state.user )
  const pageData = useSelector(state => state.page.data)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const _apiConf = useApi(apiConf)
  const shouldInit = useRef(true)
  const [autorizzato, setAutorizzato] = useState(pageData?.AUTORIZZATO)
  const [richiestaAutocert, setRichiestaAutocert] = useState(false)
  const [tipiUtentiWeb, setTipiUtentiWeb] = useState([])
  const [privacyPolicy, setPrivacyPolicy] = useState("")
  const [formAutocert, setFormAutocert] = useState({    
    NOME: user.nome,
    COGNOME: user.cognome,
    EMAIL: user.email
  })
  const [hasReadEverything, setHasReadEverything] = useState(false);

  const onScrollPrivacy = (e) => {
    const element = e.target;
    // Calcoliamo se siamo in fondo con una tolleranza di 5px
    // (scrollHeight è l'altezza totale, scrollTop la parte nascosta, clientHeight l'area visibile)
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 5) {
      setHasReadEverything(true);
    }
  };

  const resUtenteAutorizzato = useCallback((res) => {
    setAutorizzato(true)

    const dettaglioUtente = res.dettaglio_utente       

    userLoggedIn(
      dispatch,
      res?.token,
      dettaglioUtente.USERNAME,
      dettaglioUtente.NOMINATIVO,
      dettaglioUtente.NOME,
      dettaglioUtente.COGNOME,
      dettaglioUtente.CODICE_FISCALE,
      dettaglioUtente.EMAIL,
      dettaglioUtente.ID_UTENTE,
      dettaglioUtente.ID_UTENTE,
    );

    const _pageData = {
      ...pageData,
      AUTORIZZATO: true,
      SERVIZI_ABILITATI: res.servizi_abilitati,
      DETTAGLIO_UTENTE: res.dettaglio_utente,
      NOME_FILE_PRIVACY_POLICY: res.nomeFilePrivacyPolicy,
      LABEL_BTN_APPUNTAMENTO: res.lblBtnAppuntamento,
      MAX_NUM_BOTTONI_RIGA: res.maxNumBottoniRiga,
      MOSTRA_LINK_CERCA_MR: res.mostraLinkCercaMR,
      LAYOUT_CLIENTE: res.layoutCliente
    }

    const webHeader = document.querySelector(".app-container")
    if (webHeader && _pageData.LAYOUT_CLIENTE) {
      webHeader.classList.add(`layout-${_pageData.LAYOUT_CLIENTE}`)
    }

    setData(dispatch, _pageData)

    let apis = {}
    res.servizi_abilitati.forEach(s => {
      apis[s.CODICE] = { ...s, token: "" }
    })
    dispatch(apiActions.setApiCfg(apis))
  }, [dispatch, pageData])

  const getConfInit = useCallback(() => {
    _apiConf.fnAutorizza(res => {
      const _richiestaAutocertificazione = Formatter.getBoolean(res.richiesta_autocertificazione)
      setRichiestaAutocert(_richiestaAutocertificazione)
      if (_richiestaAutocertificazione) {
        setTipiUtentiWeb(res.utentiWebTipi)
        setPrivacyPolicy(res.privacyPolicy)
      } else {
        setData(dispatch, { ...pageData, AUTORIZZATO: true })
        resUtenteAutorizzato(res)
      }
    }, 
      () => {
        console.error("Utente non autorizzato")
        userLoggedOut(dispatch)
        configLoggedOut(dispatch)
      })
  }, [_apiConf, dispatch, pageData, resUtenteAutorizzato])

  const onSubmitAutocert = (data) => {
    const idUtentiWebTipi = data?.ID_UTENTI_WEB_TIPI
    const utentiWebTipi = tipiUtentiWeb.map(uw => ({ ...uw, FLG_ASSEGNATA: idUtentiWebTipi.toString() === uw.KID.toString() ? -1 : 0 }))

    const params = {
      ...data,            
      NOME: user.nome,
      COGNOME: user.cognome,
      UTENTI_WEB_TIPI: JSON.stringify(utentiWebTipi)
    }

    _apiConf.fnSalvaAutocertificazione(resUtenteAutorizzato, params);
  }

  useEffect(() => {
    if (shouldInit.current && _apiConf) {
      shouldInit.current = false
      setData(dispatch, { ...pageData, AUTORIZZATO: "" })
      getConfInit()
      navigationWeb(dispatch, [{ label: "Home", icon: <FaHome />, route: "/", active: "/" }])
    }
  }, [getConfInit, dispatch, _apiConf, pageData])

  useEffect(() => {
    if (pageData && pageData.SERVIZI_ABILITATI && pageData.SERVIZI_ABILITATI === 1) {
      navigate(API_SERVICES[pageData.SERVIZI_ABILITATI[0].CODICE].HOME_ROUTE)
    }
  }, [pageData, navigate])  

  if (Formatter.isStringaVuota(autorizzato) && richiestaAutocert === false) {
    return (
      <>
        <div className="w-100 mt-5 p-4 text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Caricamento...</span>
          </div>
          <h3 className="text-primary mt-3">Verifica autorizzazioni in corso...</h3>
        </div>
      </>
    );
  }

  if (Formatter.isStringaVuota(autorizzato) && richiestaAutocert === true) {
    return (
      <Container fluid className="bg-white p-0">
        
        <Header />
        
        <Container className="pb-4">
          <div className="my-4 border-bottom pb-4">
            <h5 className="text-primary">Gentile professionista, i suoi dati di accesso non risultano associati a un profilo attivo nel Portale Medici.</h5>
            <div className="text-secondary">Per abilitare le funzionalità della piattaforma, la invitiamo a completare il modulo di registrazione sottostante e a prendere visione dell’informativa sulla privacy.</div>
          </div>
          <FormGf id="frm-autocert" gf_init={formAutocert} gf_submit={onSubmitAutocert}>
            <Row>              
              <Col xs={12} md={6} lg={4} xl={3}>
                <IcText id='NOME' label='Nome' disabled />
              </Col>
              <Col xs={12} md={6} lg={4} xl={3}>
                <IcText id='COGNOME' label='Cognome' disabled />
              </Col>
              <Col xs={12} md={6} lg={4} xl={3}>
                <IcText id='TELEFONO' label='Telefono' gf_icona={<FaPhone />} onChange={e => setFormAutocert(prev => ({ ...prev, TELEFONO: e.target.value }))}  required />
              </Col>
              <Col xs={12} md={6} lg={4} xl={3}>
                <IcEmail id='EMAIL' label='Email' onChange={e => setFormAutocert(prev => ({ ...prev, EMAIL: e.target.value }))} required />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <IcSelect 
                  id="ID_UTENTI_WEB_TIPI" 
                  label="Tipologia utente" 
                  gf_options={tipiUtentiWeb} 
                  onChange={e => setFormAutocert(prev => ({ ...prev, ID_UTENTI_WEB_TIPI: e.target.value, SPECIALISTICA: e.target.value === TIPI_UTENTI_WEB.MMG ? "" : prev?.SPECIALISTICA }))} 
                  required />
              </Col>
              <Col xs={12} md={6}>
                <IcText 
                  id="SPECIALISTICA" 
                  label="Disciplina" 
                  onChange={e => setFormAutocert(prev => ({ ...prev, SPECIALISTICA: e.target.value }))} 
                  disabled={formAutocert?.ID_UTENTI_WEB_TIPI?.toString?.() !== TIPI_UTENTI_WEB.SPECIALISTA.toString()} 
                  required={formAutocert?.ID_UTENTI_WEB_TIPI?.toString?.() === TIPI_UTENTI_WEB.SPECIALISTA.toString()}
                  />
              </Col>
            </Row>
            <Row>              
              <Col xs={12} md={6} lg={3} xl={3}>
                <IcText id="ASL" label="ASL" onChange={e => setFormAutocert(prev => ({ ...prev, ASL: e.target.value }))} required />
              </Col>
              <Col xs={12} md={6} lg={2} xl={2}>
                <IcText id="DISTRETTO" label="Distretto" onChange={e => setFormAutocert(prev => ({ ...prev, DISTRETTO: e.target.value }))} required />
              </Col>
              <Col xs={12} md={6} lg={4} xl={4}>
                <IcText id="STRUTTURA_SANITARIA" label="Struttura sanitaria" onChange={e => setFormAutocert(prev => ({ ...prev, STRUTTURA_SANITARIA: e.target.value }))} />
              </Col>
              <Col xs={12} md={6} lg={3} xl={3}>
                <IcText id="NUM_ISCRIZIONE_ALBO" label="Num. d'iscrizione all'Ordine" max={50} onChange={e => setFormAutocert(prev => ({ ...prev, NUM_ISCRIZIONE_ALBO: e.target.value }))} required />
              </Col>
            </Row>
            <Row>
              <Col>
                <div
                  dangerouslySetInnerHTML={{ __html: privacyPolicy }}
                  className="bg-white"
                  style={{ height: '500px', overflow: 'auto' }}
                  onScroll={onScrollPrivacy}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="mt-4 d-flex flex-column align-items-center justify-content-center">
                {!hasReadEverything && (
                  <small className="text-muted mt-2">
                    * Scorri tutto il testo dell'informativa per poter accettare.
                  </small>
                )}
                <IcCheck
                  id="ACCEPT_PRIVACY_POLICY"
                  label="Accetto la Privacy Policy"
                  onChange={e => setFormAutocert(prev => ({ ...prev, ACCEPT_PRIVACY_POLICY: e.target.checked }))}
                  disabled={!hasReadEverything}
                  required
                />
                <Button variant="success" type="submit" disabled={!formAutocert?.ACCEPT_PRIVACY_POLICY}>Registrazione</Button>
              </Col>
            </Row>
          </FormGf>
        </Container>
      </Container>
    );
  }

  if (autorizzato === false) {
    return (
      <div className="w-100 mt-4 p-4 text-center">
        <h3 className="text-danger">Utente non autorizzato</h3>
        <p>Contattare l'amministrazione per abilitare l'accesso al Portale Medici.</p>
      </div>
    );
  }

  return (
    <div className="p-0">
      <>
        <Header testoPerAccedere />

        <div className='pt-4 mt-4 d-flex flex-column flex-grow-1 align-items-start justify-content-center'>
          {pageData && pageData.SERVIZI_ABILITATI && pageData.SERVIZI_ABILITATI.length > 0 && (
            <Container className='d-flex flex-row align-items-center justify-content-center flex-wrap p-4 p-md-0'>
              {pageData && pageData.SERVIZI_ABILITATI.map(servizio =>
                <div key={servizio.CODICE}
                  className='card-servizio animate__animated animate__flipInX rounded bg-white d-flex flex-row align-items-center justify-content-between p-2 m-2 m-md-4'
                  onClick={() => navigate(API_SERVICES[servizio.CODICE].HOME_ROUTE)}
                  title={servizio.DESCRIZIONE}>
                  <Image src={API_SERVICES[servizio.CODICE].IMAGE} alt={API_SERVICES[servizio.CODICE].NOME} style={{ height: '80px' }} className="mx-4" />
                  <div className="text-left w-100 d-flex flex-column">
                    <h5 className='text-primary text-left fw-bold'>{servizio.SERVIZIO}</h5>
                  </div>
                </div>
              )}
            </Container>
          )}
          {pageData && pageData.SERVIZI_ABILITATI && pageData.SERVIZI_ABILITATI.length === 0 && (
            <div className="w-100 mt-4 p-4 text-center">
              <h3 className="text-primary">Nessun servizio abilitato, contattare l'amministrazione</h3>
            </div>
          )}
        </div>
      </>
    </div>
  )
}

export default Home